import React from 'react';
import {Control} from 'react-redux-form';

import SnippetEditor from './SnippetEditor'

import './styles/margin_editor.scss';
import {tagEditorField} from "./snippetUtils";

const LetterSnippetEditor = (props) => (
  <SnippetEditor
    {...props}
    initialFormState={{
      snippet: {
        margins: {top: 1, right: 1, bottom: 1, left: 1},
        name: ''
      }
    }}
    fields={[
      {displayName: 'Name', canonicalName: 'name'},
      tagEditorField,
      MarginEditor
    ]}
  />
);

const MarginEditor = (
  <div className="control-group">
    <label className="control-label">
      Margins (in.)
    </label>
    <div className="controls">
      <div className="row">
      {
        ['top', 'right', 'bottom', 'left'].map((dir) => <div className="margin-direction col-6" key={dir}>
          <label className="margin-label">{dir}</label>
          <Control.text
            model={`local.snippet.margins[${dir}]`}
          />
        </div>)
      }
      </div>
    </div>
  </div>
);

export default LetterSnippetEditor;
